import { useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom';

import { Anchor, Space, Text, Title } from '@mantine/core';

import useAuth from '@hooks/useAuth';

import RegisterForm from '@components/RegisterForm';

export default function Register() {
  // ==========================================================================
  // General
  // ==========================================================================
  const { isAuthenticated, user, logout } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user?.role === 'customer') {
      void logout();
    }
  }, [isAuthenticated, user?.role, logout]);

  // ==========================================================================
  // Render
  // ==========================================================================
  if (isAuthenticated && user?.role === 'customer') {
    return null;
  }

  return isAuthenticated ? (
    <Navigate to="/utenti" replace={true} />
  ) : (
    <>
      <Title ta="center" fz={{ base: '1.35rem', sm: '1.8rem' }} mt="md" px="xs">
        Registrati
      </Title>
      <Text ta="center" size="sm" px="xs" style={{ wordBreak: 'break-word' }}>
        Hai già un account?{' '}
        <Anchor to="/" component={Link}>
          Accedi
        </Anchor>
      </Text>
      <Space h="xl" />
      <RegisterForm />
    </>
  );
}
